// VideoElement.js
import { useEffect, useState } from 'react'
import { FilmStripIcon } from '@phosphor-icons/react'
import { useDispatch, useSelector } from 'react-redux'
import { updateVideoPosition, updateVideoSize } from '../../../store/actions'
import VideoEdit from './VideoEdit/VideoEdit'
import { ElementWrapper } from '../components/ElementWrapper/ElementWrapper'
import styles from './VideoElement.module.scss'

const VideoElement = ({ id, initialPosition, initialSize, content, multiProps }) => {
    const dispatch = useDispatch()
    const activeMode = useSelector((state) => state.ui.activeMode)
    const [isVideoASkeleton, setIsVideoASkeleton] = useState(true) //when there is no video data to display
    const [isEditMode, setIsEditMode] = useState(false) // Local state for the edit mode
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [wrapperSize, setWrapperSize] = useState(initialSize)

    useEffect(() => {
        if (content?.videoURL) {
            setIsVideoASkeleton(false)
        }
    }, [content?.videoURL])

    const updateVideoPos = (position) => {
        dispatch(updateVideoPosition(id, position))
    }

    const updateVideoSz = (size) => {
        dispatch(updateVideoSize(id, size))
    }

    return (
        <ElementWrapper
            id={`VideoElement-${id}`}
            key={`VideoElement-${id}`}
            type={'Video'}
            setWrapperSizeTrack={setWrapperSize}
            editMode={isEditMode}
            toggleEditMode={setIsEditMode}
            initialPosition={initialPosition}
            initialSize={initialSize}
            updateElementSize={updateVideoSz}
            updateElementPosition={updateVideoPos}
            {...multiProps}
            objectId={id}
        >
            {isEditMode && (
                <div className={styles.editMenuWrapper}>
                    <VideoEdit isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} id={id} />
                </div>
            )}

            {isVideoASkeleton && (
                <div className={styles.videoSkeleton}>
                    <FilmStripIcon size="100%" weight="regular" />
                </div>
            )}
            {!isVideoASkeleton && (
                <div className={styles.videoWrapper}>
                    <iframe
                        src={content?.videoURL}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        className={styles.videoIframe}
                        style={{ pointerEvents: activeMode === 'edit' ? 'none' : 'auto' }}
                    />
                </div>
            )}
        </ElementWrapper>
    )
}

export default VideoElement
